import React, { Component } from 'react'
import { Provider } from 'mobx-react'

import './styles/main.less';
import 'bootstrap/dist/css/bootstrap.css';
import MainRoutes from './MainRoutes'
import stores from './stores'

export default class App extends Component {

  render() {
    return (
      <Provider {...stores}>
        <MainRoutes />
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// /src/App.js